<template>
  <div class="full-screen">

    <a @click="$router.go(-1)" class="close"><span class="close__title">Esc</span></a>

    <div class="add-pharmacy-wrapper">

      <div class="pre-title">Добавление стеллажа</div>

      <div class="pharmacy-add-title">
        <input type="text" :placeholder="placeholder"
               class="pharmacy-add-title__input" v-model="rName"
               @keyup="function() {
                 autoTitleIsOn = false
               }"

        >
        <input type="checkbox" class="checkbox"  name="selected-variant" id="auto" v-model="autoTitleIsOn">
        <label for="auto" class="label label--checkbox">Авто</label>
      </div>


      <!--<div class="form-block">-->
        <!--<div class="form__block-title">Вид</div>-->

        <!--<div class="form__block-value">-->


        <!--<material-select-->
                <!--:isMulti="false"-->
                <!--:title="`Выберите`"-->
                <!--:possibleValues="possibleTypes"-->
                <!--:selectedValues="selectedType"-->
                <!--@select="type = $event"-->
        <!--&gt;</material-select>-->

        <!--</div>-->
      <!--</div>-->

      <div class="product-edit__size form-block">

        <div class="rack-countour" @click.prevent="showEditContour">

          <div class="rack" :style="rack">

          </div>
          <svg xmlns="http://www.w3.org/2000/svg"
               version="1.1"
               id="backgroundimage"
               name="backgroundimage"
               :view-box.camel="viewbox"
               :style="rack"
               class="extra-background"
          >
            <g fill="none">
              <polygon id="Path" stroke="#F79700" stroke-width="1" :points="shelfContour"></polygon>
            </g>
          </svg>

        </div>

        <div class="form__block-title">Габариты, мм</div>

        <material-input parentClass="inline" label="Ширина" type="number"
                        @inputNumber="width = $event"
                        :valueNumber="width"

        ></material-input>
        <span>x</span>
        <material-input parentClass="inline" label="Высота" type="number"
                        @inputNumber="height = $event"
                        :valueNumber="height"
        ></material-input>
        <span>x</span>
        <material-input parentClass="inline" label="Глубина" type="number"
                        @inputNumber="depth = $event"
                        :valueNumber="depth"
        ></material-input>
      </div>


      <div class="form-block">
        <div class="form__block-title">Высота первой полки</div>


        <material-input parentClass="inline" label="мм" type="number"
                        @inputNumber="firstShelf = $event"
                        :valueNumber="firstShelf"
        ></material-input>
      </div>

      <div class="form-block">
        <div class="form__block-title">Количество полок</div>


        <material-input parentClass="inline" label="шт" type="number"
                        @inputNumber="shelfCount = $event"
                        :valueNumber="shelfCount"
        ></material-input>
      </div>





      <div class="" style="text-align: center; margin-top: 50px;">

        <a href="#" @click.prevent="save()" class="button">Сохранить</a>

      </div>

    </div>


    <div class="full-screen" v-if="isInEditContour">

      <a class="close" @click.prevent="isInEditContour = false"><span class="close__title">Esc</span></a>

      <div class="rack-contour-editor-holder"
           @mousemove="mousemove"
           @mouseup="mouseup"
           @mouseleave="mouseup"
      >

        <div class="rack-contour-editor"

             :style="rackEditor"
        >

          <draggable-point v-for="(point, index) in draggablePoints"
                           @mousedown="mousedown"
                           @remove="remove"
                           :top="point.y"
                           :left="point.x"
                           :type="point.type"
                           :insertPos="point.insertPos"
                           :lineIndex="point.lineIndex"
                           :id="point.id"></draggable-point>


          <svg>
            <g>
              <path :d="contour"></path>
            </g>
            <line v-for="line in guides" :x1="line.x1" :y1="line.y1" :x2="line.x2" :y2="line.y2" stroke="red"
                  stroke-width="1"></line>
            <g>
              <text v-for="line in guides" :x="(line.x1 + line.x2) / 2 - 30" :y="(line.y1 + line.y2) / 2 - 20">
                {{ Math.sqrt(Math.pow((line.x2 - line.x1), 2) + Math.pow((line.y2 - line.y1), 2)) }} см
              </text>
            </g>
          </svg>

        </div>
      </div>


      <div class="" style="text-align: center; margin-top: 50px;">

        <a href="#" @click.prevent="isInEditContour = false" class="button">Сохранить</a>

      </div>

    </div>

  </div>
</template>


<script type="text/javascript">
  import axios from 'axios';

  const TYPE_DEF = 0;
  const TYPE_MIDDLE = 1;
  const TYPE_WALL = 2;

  export default {
    name: 'rack-add',
    props: {

    },
    computed: {
      /* eslint-disable no-mixed-operators, */
      /* eslint no-param-reassign: ["error",
       { "props": true, "ignorePropertyModificationsFor": ["point","e"] }] */
      placeholder() {
        return `Стеллаж ${this.width} x ${this.height} x ${this.depth} мм, ${this.shelfCount} ${this.plural(this.shelfCount, 'полка', 'полки', 'полок')} `;
      },
      rack() {
        const ratio = Math.min(255 / this.width, 170 / this.depth);
        const height = this.depth * ratio;
        return {
          width: `${this.width * ratio}px`,
          height: `${height}px`,
          'margin-top': `${(170 - height) / 2}px`,
        };
      },
      rackEditor() {
        return {
          width: `${this.width}px`,
          height: `${this.depth}px`,
          'margin-top': `${this.depth / 2}px`,
        };
      },
      viewbox() {
        return `0, 0, ${this.shelfContourMaxX}, ${this.shelfContourMaxY}`;
      },
      bottomSide() {
        return {
          width: `${this.width}px`,
          height: `${this.depth}px`,
        };
      },
      draggablePoints() {
        const transformed = [];
        this.initContourPoints.forEach((point, index) => {
          point.id = index;
          transformed.push(point);
          const nextPoint = { type: 1, insertPos: index + 1 };
          if (index < this.initContourPoints.length - 1) {
            nextPoint.x = point.x + (this.initContourPoints[index + 1].x - point.x) / 2;
            nextPoint.y = point.y + (this.initContourPoints[index + 1].y - point.y) / 2;
          } else {
            nextPoint.x = point.x + (this.initContourPoints[0].x - point.x) / 2;
            nextPoint.y = point.y + (this.initContourPoints[0].y - point.y) / 2;
          }
          transformed.push(nextPoint);
        });
        return transformed;
      },
      contour() {
        const points = this.initContourPoints.map((stat, i) => `${i > 0 ? 'L' : ''} ${stat.x},${stat.y}`).join(' ');
        return `M ${points} Z`;
      },
      shelfContour() {
        return this.initContourPoints.map((element) => {
          this.shelfContourMaxX = Math.max(this.shelfContourMaxX, element.x);
          this.shelfContourMaxY = Math.max(this.shelfContourMaxY, element.y);
          return `${element.x} ${element.y}`;
        }).join(' ');
      },
    },
    watch: {
      placeholder(input) {
        if (this.autoTitleIsOn) {
          this.rName = input;
        }
      },
    },
    methods: {
      plural(number, one, two, five) {
        let n = Math.abs(number);
        n %= 100;
        if (n >= 5 && n <= 20) {
          return five;
        }
        n %= 10;
        if (n === 1) {
          return one;
        }
        if (n >= 2 && n <= 4) {
          return two;
        }
        return five;
      },
      showEditContour() {
        if (this.initContourPoints.length === 0) {
          //
          this.initContourPoints.push({ y: 0, x: 0, type: TYPE_DEF });
          this.initContourPoints.push({ y: 0, x: this.width, type: TYPE_DEF });
          this.initContourPoints.push({ y: this.depth, x: this.width, type: TYPE_DEF });
          this.initContourPoints.push({ y: this.depth, x: 0, type: TYPE_DEF });
        }
        this.isInEditContour = true;
      },
      remove(e) {
        if (e.type === TYPE_DEF) {
          this.initContourPoints.splice(e.id, 1);
        } else if (e.type === TYPE_WALL) {
          this.initPartitions.splice(e.lineIndex, 1);
        }
      },
      mousedown(e) {
        if (e.type === TYPE_MIDDLE) {
          this.initContourPoints.splice(e.insertPos, 0, { x: e.x, y: e.y, type: TYPE_DEF });
          e.id = e.insertPos;
        }
        this.whatToMove = e;
      },
      mousemove(e) {
        if (this.whatToMove !== null && this.whatToMove !== undefined) {
          if (this.whatToMove.type !== TYPE_WALL) {
            this.$set(this.initContourPoints[this.whatToMove.id], 'y', e.clientY - this.whatToMove.offsetY);
            this.$set(this.initContourPoints[this.whatToMove.id], 'x', e.clientX - this.whatToMove.offsetX);

            this.guides = [];
            this.initContourPoints.forEach((element) => {
              if (element.id !== this.whatToMove.id) {
                // snapping
                if (!e.shiftKey) {
                  if (Math.abs(this.initContourPoints[this.whatToMove.id].y - element.y) < 10) {
                    this.initContourPoints[this.whatToMove.id].y = element.y;
                  }

                  if (Math.abs(this.initContourPoints[this.whatToMove.id].x - element.x) < 10) {
                    this.initContourPoints[this.whatToMove.id].x = element.x;
                  }
                }

                // lines
                if (element.x === this.initContourPoints[this.whatToMove.id].x) {
                  this.guides.push(
                    {
                      x1: element.x,
                      y1: element.y,
                      x2: element.x,
                      y2: this.initContourPoints[this.whatToMove.id].y,
                    },
                  );
                }
                if (element.y === this.initContourPoints[this.whatToMove.id].y) {
                  this.guides.push(
                    {
                      x1: element.x,
                      y1: element.y,
                      x2: this.initContourPoints[this.whatToMove.id].x,
                      y2: element.y,
                    },
                  );
                }
              }
            });
          }
        }
      },
      mouseup() {
        this.guides = [];
        this.whatToMove = null;
      },
      save() {
        axios.post('/api/rackprototype/', {
          width: this.width,
          depth: this.depth,
          height: this.height,
          title: this.rName || this.placeholder,
          shelfCount: this.shelfCount,
          contour: this.initContourPoints,
          firstShelfY: this.firstShelf,

        }).then(() => {
          this.$router.go(-1);
        });
      },
    },
    data() {
      return {
        autoTitleIsOn: true,
        rName: '',
        width: 600,
        height: 1800,
        depth: 300,
        shelfCount: 1,
        firstShelf: 600,
        type: '',
        possibleTypes: [{ id: '1', title: 'Прямоугольный' }],
        selectedType: '1',
//        shelfContour: '',
        shelfContourMaxX: 0,
        shelfContourMaxY: 0,
        initContourPoints: [],
        guides: [],
        isInEditContour: false,
        isChangeContourHappen: false,
        whatToMove: null,
      };
    },
  };
</script>


<style type="text/css" lang="less" scoped="true">

  .inline{
    display: inline-block;
    vertical-align: middle;
    width: 74px;
  }


  .form__block-title{
    display: inline-block;
    width: 150px;
  }

  .form__block-value{
    display: inline-block;
    width: 320px;
  }

  .rack-countour{
    position: absolute;
    background: #fff;
    width: 255px;
    height: 170px;
    top: 0px;
    left: 430px;
  }

  .product-edit__size{
    position: relative;
  }


  .rack {
    border: 2px solid #c2c2c2;
    margin: auto;
  }

  .extra-background{
    position: absolute;
    top:0;
  }

  .wall-point{
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #333;
    position: absolute;
    margin: -9px 0 0 -9px;
  }


  svg{
    width: 100%;
    height: 100%;
  }

  path {
    stroke: #F79700;
    stroke-width: 2px;
    fill: transparent;
  }

  .rack-contour-editor-holder{
    padding: 10px;
  }

  .rack-contour-editor{

    background: #FFFFFF;
    margin: auto;
    position: relative;
  }


</style>


// WEBPACK FOOTER //
// RackAdd.vue?7d97d8e6